import {Component, ElementRef, forwardRef, Injector, Input, OnChanges, OnInit, ChangeDetectionStrategy} from '@angular/core';
import {NG_VALUE_ACCESSOR} from '@angular/forms';
import {TypedSimpleChanges} from '../../../common/typed-on-changes';
import {AutocompleteProviderConfig, DefinedListAutocompleteService} from '../../autocomplete';
import {AutocompleteInputComponent} from '../../autocomplete-input';
import {Portfolio} from '../inv-portfolio';
import {InvPortfolioService} from '../inv-portfolio.service';

@Component({
    selector: 'portfolio-id-select',
    templateUrl: '../../../components/autocomplete-input/autocomplete-input.component.html',
    styleUrls: ['../../autocomplete-input/autocomplete-input.component.scss'],
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => PortfolioIdSelectComponent),
            multi: true
        }
    ],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class PortfolioIdSelectComponent extends AutocompleteInputComponent<number, Portfolio>
    implements OnInit, OnChanges {

    @Input()
    public invEntityId: number | undefined;

    constructor(
        elementRef: ElementRef,
        injector: Injector,
        private invPortfolioService: InvPortfolioService
    ) {
        super(elementRef, injector);
    }

    public override ngOnInit(): void {
        this.updateAutocompleteConfig();

        super.ngOnInit();
    }

    public override ngOnChanges(changes: TypedSimpleChanges<PortfolioIdSelectComponent>): void {
        if (changes.invEntityId) {
            this.updateAutocompleteConfig();
        }

        super.ngOnChanges(changes);
    }

    protected override outerValueToInnerValue(outerValue: number): Portfolio {
        return outerValue && this.invPortfolioService.getPortfolio(undefined, outerValue) || null;
    }

    protected override innerValueToOuterValue(innerValue: Portfolio): number {
        return innerValue && innerValue.id || null;
    }

    private updateAutocompleteConfig(): void {
        const {portfolios} = this.invPortfolioService.getCached();
        const filteredPortfolios = this.invEntityId
            ? portfolios.filter(portfolio => portfolio.investmentEntityId === this.invEntityId)
            : portfolios;

        const autocompleteProvider = new DefinedListAutocompleteService<Portfolio>({
            list:          [...filteredPortfolios]
                               .sort((p1, p2) =>
                                   p1.name.localeCompare(p2.name, undefined, {numeric: true})
                               ),
            filterByField: 'name'
        });

        if (!this.autocompleteConfig) {
            this.autocompleteConfig = {
                type:                      {
                                               provider: autocompleteProvider
                                           } as AutocompleteProviderConfig<Portfolio>,
                displayValue:              (portfolio: Portfolio) => portfolio && portfolio.name || '',
                allowVariantsForEmptyTerm: true,
                disallowEmptySelect:       true,
                selectAllOnFocus:          true
            };
        } else {
            (this.autocompleteConfig.type as AutocompleteProviderConfig<Portfolio>).provider = autocompleteProvider;
        }
    }

}
